export enum ChatMessageFeedback {
  Like,
  Dislike,
}
